// extracted by mini-css-extract-plugin
export default {"container":"style_container__bh55+","text":"style_text__XzlFW","text_title":"style_text_title__hN8Mf","text_value":"style_text_value__71lwI"};